import { Dropdown, IDropdown, Typography } from '@sanlam-glacier/app-common/components';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import styles from './statement-form-sections.module.scss';
import { StatementTypes } from 'modules/clients/types/client.enum';
import { StatementFormValues } from 'modules/clients/types/client.types';

type StatementTypeDropdownProps = {
  control: Control<StatementFormValues, StatementFormValues, StatementFormValues>;
  setValue: UseFormSetValue<StatementFormValues>;
  min30DaysStart: Date;
};

export const StatementTypeDropdown = ({
  control,
  setValue,
  min30DaysStart
}: StatementTypeDropdownProps) => {
  const statementTypesList: StatementTypes[] = Object.values(StatementTypes);

  return (
    <div className={styles.selectionContainers}>
      <Typography
        variant={Typography.VARIANT.H5}
        weight={Typography.WEIGHT.MEDIUM}
        color={Typography.COLOR.DEFAULT}
      >
        Statement type
      </Typography>
      <Controller
        name='statementType'
        control={control}
        render={({ field }) => (
          <Dropdown
            className={styles.filter}
            placeholder='Select statement type'
            multiSelect={false}
            chipLimit={1}
            items={statementTypesList}
            maxHeight={224}
            onChange={(items) => {
              const categories = items as IDropdown[];
              field.onChange(categories ?? null);
              setValue('dateRange.0', min30DaysStart);
              setValue('dateRange.1', null);
            }}
            popperPlacement={Dropdown.POSITION.BOTTOM}
          />
        )}
      />
    </div>
  );
};
